export const GET_SIMPLE_AMMUNITION_PENDING = "GET_SIMPLE_AMMUNITION_PENDING";
export const GET_MORE_SIMPLE_AMMUNITION_PENDING =
  "GET_MORE_SIMPLE_AMMUNITION_PENDING";
export const GET_SIMPLE_AMMUNITION_SUCCESS = "GET_SIMPLE_AMMUNITION_SUCCESS";
export const GET_MORE_SIMPLE_AMMUNITION_SUCCESS =
  "GET_MORE_SIMPLE_AMMUNITION_SUCCESS";
export const RESET_SIMPLE_AMMUNITION = "RESET_SIMPLE_AMMUNITION";
export const GET_HOME_AMMUNITION = "GET_HOME_AMMUNITION";
export const RESET_HOME_AMMUNITION = "RESET_HOME_AMMUNITION";
